
  import { hydrate } from "svelte";
  import App from "/Users/kamov/repo/website/src/plugin/projects/radicals/App.svelte";

  const query = document.querySelectorAll('._ccc8df55a4cd509a31f1e9d5ab61de6dd72a3997d6d5caf79a3de9f5fbb31b90');
  for (const target of query) {
    const attrs = target.getAttribute('data-props');
    const props = JSON.parse(attrs) ?? {};
    hydrate(App, { target, props });
  }
